<template>
  <div>
    <v-btn color="secondary" @click.native.stop.prevent="toggleModal">
      Verify
    </v-btn>
    <v-dialog v-model="isModalOpen" max-width="630px" persistent>
      <v-toolbar dark color="primary" class="d-flex justify-center align-center">
        <v-toolbar-title class="body-heading-small">Verify Rewards Request</v-toolbar-title>
      </v-toolbar>
      <v-card class="modal-content-container">
        <v-card-title class="d-flex justify-center">
          <span class="body-heading-small ma-8">Once you verified, your child will receive the reward soon!</span>
        </v-card-title>
        <v-card-text>
          <v-row class="px-3 justify-space-between">
            <v-btn color="secondary" class="modal-btn" @click="verify">Verify</v-btn>
            <v-btn color="secondary" class="modal-btn" outlined @click="toggleModal">Cancel</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "VerifyPointRedemptionRequestModal",

    data() {
      return {
        isModalOpen: false,
      };
    },

    props: {
      itemId: {
        required: true,
      },
      childId: {
        required: true,
      },
    },

    methods: {
      toggleModal() {
        this.isModalOpen = !this.isModalOpen;
      },

      verify() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .put(`/children/${this.childId}/orders/${this.itemId}/verify`)
          .then((response) => {
            if (response && response.data) {
              this.verifySuccess();
            } else {
              this.$store.commit("setError", {
                message: this.$formatter.getErrorMsg(),
                type: "error",
              });
              this.isModalOpen = false;
              this.$store.commit("setLoadingStatus", false);
            }
          })
          .catch((error) => {
            console.error(error);
            this.verifyFail(error);
          });
      },

      verifySuccess() {
        this.$store.commit("setError", {
          message: "You have approved the order request, your kid will receive the reward soon.",
          type: "success",
        });

        this.$store.commit("approveGiftPurchaseRequest", this.itemId);
        this.isModalOpen = false;
        this.$store.commit("setLoadingStatus", false);
      },

      verifyFail(error) {
        console.log(error);
        this.$store.commit("setError", {
          message: this.$formatter.getErrorMsg(error),
          type: "error",
        });

        this.isModalOpen = false;
        this.$store.commit("setLoadingStatus", false);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/PurchasedGift/VerifyPointRedemptionRequestModal.vue